/**
 * Build 96.25 — PostHog analytics wrapper (ersätter Plausible).
 *
 * Konfiguration enligt driftbeslut:
 *   - EU Cloud (eu.i.posthog.com)
 *   - persistence: "memory" → INGA cookies, ingen localStorage, ingen sessionStorage
 *   - cookieless_mode: "always" → server-hashat pseudonymt ID, ingen klient-persistens
 *   - capture_pageview: "history_change" → PostHog skickar $pageview
 *     vid initial mount OCH vid varje React-Router (history.pushState) navigering
 *   - autocapture: false → inga automatiska klick/formulärhändelser
 *   - person_profiles: "identified_only" → ingen automatisk personprofil, ingen identify()
 *   - disable_session_recording, disable_surveys → av
 *   - capture_performance: true → Web Vitals (LCP, FCP, CLS, INP, FID)
 *
 * Publik projektnyckel injiceras via .env-variabel (REACT_APP_POSTHOG_KEY).
 * Om nyckeln saknas returnerar init() utan att göra något (t.ex. lokala tester).
 */
import posthog from "posthog-js";

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) return; // ingen nyckel = ingen analys (t.ex. utveckling)
  const host = process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com";
  posthog.init(key, {
    api_host: host,
    // Modernes defaults-schema krävs för cookieless_mode i posthog-js >= 1.400.
    defaults: "2026-05-30",
    // Bekräftat driftsläge — cookielöst med server-side hash för unika-räkning.
    cookieless_mode: "always",
    // "memory" = SDK håller intern state i minnet, skriver INGET till cookies/localStorage/sessionStorage.
    persistence: "memory",
    autocapture: false,
    // "history_change" = SDK skickar $pageview vid initial mount OCH vid varje history.pushState/popstate.
    capture_pageview: "history_change",
    capture_pageleave: false,
    capture_performance: true, // Web Vitals
    disable_session_recording: true,
    disable_surveys: true,
    person_profiles: "identified_only",
    loaded: () => { initialized = true; },
  });
  initialized = true;
}

